

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {IErrors} from "@/model/IErrors";
import {ILocker} from "@/model/Locker/lockerInterfaces";
import {IAuthUserData} from "@/store/modules/authModule";
import {EPermissionActions} from "@/model/EPermissionActions";

const lockerModule = namespace("lockerModule");
const authModule = namespace("authModule");

@Component({
  name: 'LockerExternalNameDialog'
})
export default class LockerExternalNameDialog extends Vue {

  @Prop()
  protected locker!: ILocker;

  @Prop({default: false})
  protected loading!: boolean;

  @lockerModule.Action('changeExternalName')
  protected changeExternalName!: ({lockerId, externalName}: {lockerId: number, externalName: string}) => void;

  @lockerModule.Action('clearErrors')
  protected clearErrors!: () => void;

  @authModule.Getter('userData')
  protected authUser!: IAuthUserData;

  @lockerModule.Getter('errors')
  protected errors!: IErrors;

  protected externalName: string = '';
  protected show: boolean = false;
  protected subscribes: IOnOffHandlers = {};

  protected get canEdit(): boolean {
    return this.$canAction(
        EPermissionActions.ACTION_LOCKERS
    );
  }

  public created() {
    this.subscribes = this.$ons({
      'login.OK': this.onClose,
      'backend.call.OK.lockerUpdated': this.onClose,
    });
  }

  public beforeDestroy() {
    this.$offs(this.subscribes);
  }

  protected onClose() {
    this.clearErrors();
    this.show = false;
  }

  protected onShow() {
    this.externalName = this.locker.external_name || '';
    this.show = true;
  }

  protected onSubmit() {
    if (this.locker.external_name !== this.externalName) {
      this.changeExternalName({
        lockerId: this.locker.id,
        externalName: this.externalName
      });
    } else {
      this.onClose();
    }
  }

}
